import { forkJoin, mergeMap, of } from "rxjs";
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as FlatActions from '@medsurf/flat-actions';
import * as FlatStates from '@medsurf/flat-states';

@Injectable()
export class MediaEntityFacade {
  constructor(protected store: Store) {
  }

  //<editor-fold desc="Selectors">

  //</editor-fold>

  //<editor-fold desc="Requests">

  static removeMedia(store: Store,
                     id: string,
                     clusterParentUpdate = false) {
    // Get Data
    const typedMedias = store.selectSnapshot(FlatStates.MediaEntityState.typedEntities$);
    const currentSelectedMedia = store.selectSnapshot(FlatStates.SearchControlState.currentSelectedMedia$);

    // Get Media
    const media = structuredClone(typedMedias[id]);

    // Remove Media
    if (currentSelectedMedia === media) {
      return store.dispatch(new FlatActions.SearchControlActions.SetCurrentSelectedMediaResult(null)).pipe(
        mergeMap(() =>
          store.dispatch(new FlatActions.SlideAuthorActions.CollapseMedia(true, false))
        ),
        mergeMap(() =>
          store.dispatch(new FlatActions.BulkEditAuthorActions.RemoveMedia(id))
        ),
        mergeMap(() =>
          store.dispatch(new FlatActions.MediaEntityActions.RemoveEntity(media))
        )
      );
    } else {
      return store.dispatch(new FlatActions.BulkEditAuthorActions.RemoveMedia(id)).pipe(
        mergeMap(() =>
          store.dispatch(new FlatActions.MediaEntityActions.RemoveEntity(media))
        )
      );
    }
  }

  static removeMedias(store: Store,
                      ids: string[]) {
    if (ids.length === 0) {
      return of([]);
    }

    // Remove Medias
    return of({}).pipe(
      mergeMap(() =>
        forkJoin(ids.map(id => MediaEntityFacade.removeMedia(store, id, true)))
      )
    );
  }

  //</editor-fold>
}
